import React from 'react';
import RouterPath from './Routes/router'; 

function App() {
  return (
    <div>
      <RouterPath />
    </div>
  );
}

export default App;